import { jsxs as r, Fragment as l, jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ r(l, { children: [
  /* @__PURE__ */ C("path", { d: "M5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8H6C6.55229 8 7 7.55228 7 7C7 6.44772 6.55229 6 6 6H5Z", fill: "#100061" }),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8H19C19.5523 8 20 7.55228 20 7C20 6.44772 19.5523 6 19 6H10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18H19C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16H10Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M4 12C4 11.4477 4.44772 11 5 11H6C6.55229 11 7 11.4477 7 12C7 12.5523 6.55229 13 6 13H5C4.44772 13 4 12.5523 4 12Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M4 17C4 16.4477 4.44772 16 5 16H6C6.55229 16 7 16.4477 7 17C7 17.5523 6.55229 18 6 18H5C4.44772 18 4 17.5523 4 17Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
